define("settings/components/profiles/device-notify", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/fetch", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _fetch, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/fetch",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper">
    {{#each this.deviceOptions as |device|}}
      <label class="o--checkbox--switch" data-test-id="device-option">
        <Input @checked={{device.shouldRemove}} @type="checkbox" {{on "change" (perform this.onChange device)}} />
        <div class="o--checkbox__track" data-test-id="device-checkbox">
          <div class="o--checkbox__knob"></div>
        </div>
        <span class="o--checkbox__label">
          {{device.name}}
        </span>
      </label>
    {{/each}}
  </div>
  */
  {
    "id": "Sp4WlUhd",
    "block": "[[[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,0,[\"deviceOptions\"]]],null]],null],null,[[[1,\"    \"],[10,\"label\"],[14,0,\"o--checkbox--switch\"],[14,\"data-test-id\",\"device-option\"],[12],[1,\"\\n      \"],[8,[39,2],[[4,[38,3],[\"change\",[28,[37,4],[[30,0,[\"onChange\"]],[30,1]],null]],null]],[[\"@checked\",\"@type\"],[[30,1,[\"shouldRemove\"]],\"checkbox\"]],null],[1,\"\\n      \"],[10,0],[14,0,\"o--checkbox__track\"],[14,\"data-test-id\",\"device-checkbox\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--checkbox__knob\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n        \"],[1,[30,1,[\"name\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[1]],null],[13]],[\"device\"],false,[\"each\",\"-track-array\",\"input\",\"on\",\"perform\"]]",
    "moduleName": "settings/components/profiles/device-notify.hbs",
    "isStrictMode": false
  });
  let DeviceNotifyComponent = _exports.default = (_class = class DeviceNotifyComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _defineProperty(this, "onChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (device) {
          try {
            const url = `/api/v2/devices/${device.id}/social_profiles/${this.args.socialProfile.id}`;
            const method = device.shouldRemove ? 'DELETE' : 'POST';
            const action = device.shouldRemove ? 'remove' : 'add';
            yield (0, _fetch.fetch)(url, {
              method
            });
            this.args.addRemoveDevice(this.args.socialProfile, action, device.id);
          } catch (error) {
            this.errors.log(error);
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              sticky: false
            });
          }
        }
      }), null, "onChange", "keepLatest"));
    }
    get deviceOptions() {
      return this.args.devices?.map(device => ({
        id: device.id,
        name: device.name,
        shouldRemove: !!device.socialProfiles.find(profile => profile.id === this.args.socialProfile.id)
      }));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DeviceNotifyComponent);
});